import React from 'react';
import {
  HeaderStyled,
  HeadingContainerStyled,
  HeadingText,
} from './CategoryHeading.styles';

const CategoryHeading = ({
  headerLeftTitle = '',
  headerRightTitle = '',
  paraText = '',
  headerLeftStyle = false,
}) => {
  return (
    <HeadingContainerStyled>
      <HeaderStyled headerLeftStyle={headerLeftStyle}>
        {headerLeftTitle}
        <span className='subHeaderStyle'> {headerRightTitle}</span>{' '}
      </HeaderStyled>
      {paraText && <span className='paraHeaderStyle'>{paraText}</span>}
    </HeadingContainerStyled>
  );
};

export default CategoryHeading;
